export const GRID_DENSITIES = [1, 2, 3] as const;
export type GridDensity = (typeof GRID_DENSITIES)[number];

export const DEFAULT_GRID_DENSITY: GridDensity = 2;
export const GRID_DENSITY_STORAGE_KEY = "hw.grid-density";

export function isGridDensity(value: unknown): value is GridDensity {
  return value === 1 || value === 2 || value === 3;
}

export function readGridDensity(
  storage: Pick<Storage, "getItem"> | null = typeof localStorage === "undefined"
    ? null
    : localStorage,
): GridDensity {
  if (!storage) {
    return DEFAULT_GRID_DENSITY;
  }
  try {
    const raw = storage.getItem(GRID_DENSITY_STORAGE_KEY);
    const parsed = raw === null ? null : Number(raw);
    return isGridDensity(parsed) ? parsed : DEFAULT_GRID_DENSITY;
  } catch {
    return DEFAULT_GRID_DENSITY;
  }
}

export function writeGridDensity(
  density: GridDensity,
  storage: Pick<Storage, "setItem"> | null = typeof localStorage === "undefined"
    ? null
    : localStorage,
): void {
  if (!storage) {
    return;
  }
  try {
    storage.setItem(GRID_DENSITY_STORAGE_KEY, String(density));
  } catch {
    // Device storage can be unavailable; keep in-memory preference only.
  }
}
